<template>
  <v-col class="v-col-12">
    <b class="text-color-0">Cupom</b>
  </v-col>
  <v-col class="v-col-12 pt-1">
    <v-text-field variant="outlined" v-model="cupom" hide-details @click:append="cupom = ''">
      <template v-slot:append>
        <v-btn class="bg-color-2 text-color-white" variant="tonal" block size="x-large" @click="insereCupom(cupom)">
          Usar
        </v-btn>
      </template>
    </v-text-field>
  </v-col>
  <v-col class="v-col-12 pt-1 d-flex flex-wrap align-center justify-start py-0">
    <v-skeleton-loader :loading="loadingCupons" type="image" width="100%" height="50px">
      <div v-for="(c, index) in getCupons" v-bind:key="index" @click="removeCupom(c);" class="position-relative my-2 ms-2">
        <div class="cupom-delete"><v-icon icon="mdi-close"></v-icon></div>
        <span class="text-uppercase cupom mr-3 mt-3 rounded">{{ c.cod_coupon }}</span>
      </div>
    </v-skeleton-loader>
  </v-col>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
  name: 'Cupons',
  data(){
    return {
      cupom: ""
    }
  },
  computed: {
    ...mapGetters('cupons', {
      getCupons: 'getCupons'
    }),
    ...mapState('cupons', {
      loadingCupons: 'loadingCupons'
    }),
    ...mapGetters('cart', {
      getTotalValueCart: 'getTotalValueCart',
    }),
  },
  methods: {
    ...mapActions('cupons', {
      checkCupom: 'checkCupom',
      addCupom: 'addCupom',
      delCupom: 'delCupom'
    }),
    insereCupom(cupom){
      this.checkCupom(cupom).then(function(response){
        if(response.cod == 100 && response.return != null){
          if(this.getTotalValueCart >= response.return.min_value_coupon){
            this.addCupom(response.return).then(function(response2){
              if(response2.cod != 200){
                this.emitter.emit('dialogMessage', { title: "Atenção!", message: response2.msg });
              } else {
                this.cupom = "";
              }
            }.bind(this));
          } else {
            this.emitter.emit('dialogMessage', { title: "Atenção!", message: "O valor mínimo para aplicar este cupom é de R$ " + parseFloat(response.return.min_value_coupon).toFixed(2).replace(".", ",") });
          }
        } else {
          this.emitter.emit('dialogMessage', { title: "Atenção!", message: response.msg });
        }
      }.bind(this));
    },
    removeCupom(cupom){
      this.delCupom(cupom).then(function(response){
        if(response.cod != 300){
          this.emitter.emit('dialogMessage', { title: "Atenção!", message: response.msg });
        }
      }.bind(this));
    }
  }
}
</script>